/*
  ci-newsletter-popup — comportement du popup newsletter (section ci-newsletter-popup).
  Déclenchement : délai, défilement ou intention de sortie, après le choix cookies.
  Mémoire (localStorage) : inscrit = plus jamais ; fermé = pause de N jours + étiquette de rappel.
*/
(function () {
  if (window.customElements.get('ci-newsletter-popup')) return;

  var DAY = 86400000;
  var KEY_SUBSCRIBED = 'ci_nlp_subscribed';
  var KEY_DISMISSED = 'ci_nlp_dismissed_until';
  var KEY_TEASER = 'ci_nlp_teaser_hidden_until';
  var KEY_SESSION = 'ci_nlp_shown';
  var KEY_PENDING = 'ci_nlp_pending';
  var CONSENT_MAX_WAIT = 25000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  function until(k) { var v = parseInt(lsGet(k), 10); return isNaN(v) ? 0 : v; }
  function media(q) { return window.matchMedia && window.matchMedia(q).matches; }
  function reducedMotion() { return media('(prefers-reduced-motion: reduce)'); }
  function track(name) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (e) {}
  }

  class CiNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.ready) return;
      this.ready = true;

      var d = this.dataset;
      this.sid = d.sectionId;
      this.cfg = {
        enabled: d.enabled === 'true',
        delay: Math.max(3, parseInt(d.delay, 10) || 12) * 1000,
        scroll: parseInt(d.scroll, 10) || 0,
        exitIntent: d.exitIntent === 'true',
        frequency: Math.max(1, parseInt(d.frequency, 10) || 14) * DAY,
        teaser: d.teaser === 'true',
        pageType: d.pageType || '',
        design: d.designMode === 'true',
        editorView: d.editorView === 'success' ? 'success' : 'signup'
      };
      this.views = {
        signup: this.querySelector('[data-ci-nlp-view="signup"]'),
        success: this.querySelector('[data-ci-nlp-view="success"]')
      };
      this.form = this.views.signup;
      this.email = this.querySelector('input[type="email"]');
      this.errorBox = this.querySelector('[data-ci-nlp-error]');
      this.errorText = this.querySelector('[data-ci-nlp-error-text]');
      this.submitBtn = this.querySelector('[data-ci-nlp-submit]');
      this.teaserEl = this.querySelector('[data-ci-nlp-teaser]');
      this.live = this.querySelector('[data-ci-nlp-live]');
      this.state = (this.views.success && this.views.success.dataset.ciNlpState) || 'idle';
      this.t0 = Date.now();
      this.bind();

      if (this.cfg.design) return this.setupEditor();

      var params = new URLSearchParams(window.location.search);
      var force = params.get('ci_popup');
      var ours = window.location.hash === '#ci-popup-form' || ssGet(KEY_PENDING) === '1';
      ssDel(KEY_PENDING);

      if (force === 'reset') {
        [KEY_SUBSCRIBED, KEY_DISMISSED, KEY_TEASER].forEach(lsDel);
        ssDel(KEY_SESSION);
      }
      if (this.state === 'success') lsSet(KEY_SUBSCRIBED, String(Date.now()));

      if (force === 'open') return this.open('signup');
      if (ours && this.state === 'success') { this.cleanUrl(); return this.open('success'); }
      if (ours && this.state === 'error') { this.cleanUrl(); this.open('signup'); return this.showError(false, true); }

      if (!this.cfg.enabled || lsGet(KEY_SUBSCRIBED)) return;
      if (this.fromEmail(params)) { lsSet(KEY_SUBSCRIBED, String(Date.now())); return; }
      if (until(KEY_DISMISSED) > Date.now() || ssGet(KEY_SESSION)) return this.showTeaser();

      this.loadConsentApi();
      this.arm();
    }

    disconnectedCallback() {
      clearTimeout(this.retry);
      if (this.disarm) this.disarm();
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
      if (this.consentListener) document.removeEventListener('visitorConsentCollected', this.consentListener);
      document.documentElement.classList.remove('ci-nlp-lock');
    }

    bind() {
      var self = this;
      this.querySelectorAll('[data-ci-nlp-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      this.dialog.addEventListener('pointerdown', function (e) { self.downOnBackdrop = e.target === self.dialog; });
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog && self.downOnBackdrop) self.close();
        self.downOnBackdrop = false;
      });

      var openBtn = this.querySelector('[data-ci-nlp-open]');
      if (openBtn) openBtn.addEventListener('click', function () { self.open('signup'); });
      var teaserClose = this.querySelector('[data-ci-nlp-teaser-close]');
      if (teaserClose) teaserClose.addEventListener('click', function () { self.hideTeaser(true); });
      var copyBtn = this.querySelector('[data-ci-nlp-copy]');
      if (copyBtn) copyBtn.addEventListener('click', function () { self.copyCode(copyBtn); });

      if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
      if (this.email) {
        this.email.addEventListener('input', function () {
          if (self.email.getAttribute('aria-invalid') === 'true' && EMAIL_RE.test(self.email.value.trim())) self.hideError();
        });
      }
    }

    /* ---------- Déclenchement ---------- */

    arm() {
      var self = this;
      var fired = false;
      var offs = [];
      var fire = function () {
        if (fired) return;
        fired = true;
        offs.forEach(function (off) { off(); });
        self.tryOpen();
      };
      this.disarm = function () { offs.forEach(function (off) { off(); }); };

      var timer = setTimeout(fire, this.cfg.delay);
      offs.push(function () { clearTimeout(timer); });

      if (this.cfg.scroll > 0) {
        var onScroll = function () {
          if (Date.now() - self.t0 < 4000) return;
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && (window.scrollY / max) * 100 >= self.cfg.scroll) fire();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        offs.push(function () { window.removeEventListener('scroll', onScroll); });
      }

      if (this.cfg.exitIntent && media('(hover: hover) and (pointer: fine) and (min-width: 990px)')) {
        var onOut = function (e) {
          if (Date.now() - self.t0 < 4000) return;
          if (!e.relatedTarget && e.clientY <= 0) fire();
        };
        document.addEventListener('mouseout', onOut);
        offs.push(function () { document.removeEventListener('mouseout', onOut); });
      }
    }

    tryOpen() {
      var self = this;
      if (this.dialog.open) return;
      var later = function (ms) {
        clearTimeout(self.retry);
        self.retry = setTimeout(function () { self.tryOpen(); }, ms);
      };

      // Laisser le visiteur répondre au bandeau cookies d'abord (avec une limite, pour ceux qui l'ignorent).
      if (this.consentPending() && Date.now() - this.t0 < CONSENT_MAX_WAIT) {
        if (!this.consentListener) {
          this.consentListener = function () { later(1500); };
          document.addEventListener('visitorConsentCollected', this.consentListener, { once: true });
        }
        return later(3000);
      }
      if (this.otherOverlayOpen()) return later(4000);
      if (document.visibilityState === 'hidden') {
        var onVisible = function () {
          if (document.visibilityState !== 'visible') return;
          document.removeEventListener('visibilitychange', onVisible);
          later(800);
        };
        document.addEventListener('visibilitychange', onVisible);
        return;
      }
      this.open('signup');
    }

    loadConsentApi() {
      try {
        if (window.Shopify && !Shopify.customerPrivacy && typeof Shopify.loadFeatures === 'function') {
          Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
        }
      } catch (e) {}
    }

    consentPending() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function') return false;
      try { return !!cp.shouldShowBanner(); } catch (e) { return false; }
    }

    otherOverlayOpen() {
      if (/\boverflow-hidden/.test(document.body.className)) return true;
      return !!document.querySelector(
        'cart-drawer.active, .drawer.active, header-drawer > details[open], details-modal > details[open], ' +
        'quick-add-modal[open], modal-dialog[open], dialog[open]:not(.ci-nlp__dialog)'
      );
    }

    fromEmail(params) {
      var medium = (params.get('utm_medium') || '').toLowerCase();
      var source = (params.get('utm_source') || '').toLowerCase();
      return medium === 'email' || medium === 'e-mail' || /klaviyo|shopify_email|shopify-email|newsletter/.test(source) || params.has('_kx');
    }

    /* ---------- Ouverture / fermeture ---------- */

    open(view) {
      var self = this;
      clearTimeout(this.retry);
      if (this.disarm) this.disarm();
      this.setView(view);
      if (this.dialog.open) return;

      var img = this.querySelector('[data-ci-nlp-img]');
      if (img) img.loading = 'eager';
      this.lastFocus = document.activeElement;
      this.hideTeaser(false);
      document.documentElement.classList.add('ci-nlp-lock');
      try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); }
      void this.dialog.offsetWidth; // force le calcul de l'état initial pour que la transition joue
      this.dialog.classList.add('is-open');

      if (view === 'signup' && this.email && media('(hover: hover) and (pointer: fine)')) {
        setTimeout(function () {
          try { self.email.focus({ preventScroll: true }); } catch (e) { self.email.focus(); }
        }, 80);
      }
      if (!this.cfg.design) {
        ssSet(KEY_SESSION, '1');
        track(view === 'success' ? 'ci_newsletter_popup_success_view' : 'ci_newsletter_popup_view');
      }
    }

    close() {
      if (!this.dialog.open) return;
      var self = this;
      var wait = reducedMotion() ? 0 : 380;
      this.dialog.classList.remove('is-open');
      setTimeout(function () {
        if (!self.dialog.open) return;
        self.dialog.close();
        document.documentElement.classList.remove('ci-nlp-lock');
        if (self.lastFocus && typeof self.lastFocus.focus === 'function' && document.contains(self.lastFocus)) {
          try { self.lastFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      }, wait);

      if (this.cfg.design || this.view === 'success' || lsGet(KEY_SUBSCRIBED)) return;
      lsSet(KEY_DISMISSED, String(Date.now() + this.cfg.frequency));
      track('ci_newsletter_popup_dismiss');
      setTimeout(function () { self.showTeaser(); }, wait + 500);
    }

    setView(view) {
      var success = view === 'success';
      if (this.views.signup) this.views.signup.hidden = success;
      if (this.views.success) this.views.success.hidden = !success;
      this.dialog.setAttribute('aria-labelledby', (success ? 'CiNlpTitleOk-' : 'CiNlpTitle-') + this.sid);
      this.dialog.setAttribute('aria-describedby', (success ? 'CiNlpDescOk-' : 'CiNlpDesc-') + this.sid);
      this.view = success ? 'success' : 'signup';
    }

    /* ---------- Étiquette de rappel ---------- */

    showTeaser() {
      var teaser = this.teaserEl;
      if (!teaser || !this.cfg.teaser || this.cfg.design) return;
      if (lsGet(KEY_SUBSCRIBED) || until(KEY_TEASER) > Date.now()) return;
      if (this.cfg.pageType === 'product' && media('(max-width: 749px)')) return;
      teaser.hidden = false;
      void teaser.offsetWidth;
      teaser.classList.add('is-visible');
    }

    hideTeaser(remember) {
      var teaser = this.teaserEl;
      if (!teaser) return;
      teaser.classList.remove('is-visible');
      if (remember) {
        lsSet(KEY_TEASER, String(Date.now() + this.cfg.frequency));
        setTimeout(function () { teaser.hidden = true; }, reducedMotion() ? 0 : 500);
      } else {
        teaser.hidden = true;
      }
    }

    /* ---------- Formulaire ---------- */

    onSubmit(e) {
      if (this.submitBtn && this.submitBtn.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
      var value = this.email ? this.email.value.trim() : '';
      if (!EMAIL_RE.test(value)) {
        e.preventDefault();
        this.showError(true, true);
        return;
      }
      this.email.value = value;
      ssSet(KEY_PENDING, '1');
      if (this.submitBtn) {
        this.submitBtn.dataset.label = this.submitBtn.textContent;
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.submitBtn.textContent = 'Un instant…';
      }
      track('ci_newsletter_popup_submit');
      // Envoi natif : la page se recharge avec ?customer_posted=true et le popup rouvre sur le code.
    }

    showError(useDefaultText, focus) {
      if (!this.errorBox) return;
      if (useDefaultText && this.errorText && this.errorBox.dataset.defaultError) {
        this.errorText.textContent = this.errorBox.dataset.defaultError;
      }
      this.errorBox.hidden = false;
      if (this.email) {
        this.email.setAttribute('aria-invalid', 'true');
        if (focus) {
          var input = this.email;
          setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 90);
        }
      }
    }

    hideError() {
      if (this.errorBox) this.errorBox.hidden = true;
      if (this.email) this.email.removeAttribute('aria-invalid');
    }

    copyCode(btn) {
      var self = this;
      var codeEl = this.querySelector('[data-ci-nlp-code]');
      var code = codeEl ? codeEl.textContent.trim() : '';
      if (!btn.dataset.labelIdle) btn.dataset.labelIdle = btn.textContent;
      var done = function () {
        btn.textContent = btn.dataset.labelDone || 'Copié';
        if (self.live) self.live.textContent = 'Code ' + code + ' copié.';
        clearTimeout(self.copyTimer);
        self.copyTimer = setTimeout(function () { btn.textContent = btn.dataset.labelIdle; }, 2200);
      };
      var fallback = function () {
        if (codeEl) {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          try { document.execCommand('copy'); } catch (e) {}
        }
        done();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
      if (!this.cfg.design) track('ci_newsletter_popup_copy');
    }

    cleanUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.pathname + url.search);
      } catch (e) {}
    }

    /* ---------- Éditeur de thème ---------- */

    setupEditor() {
      var self = this;
      this.onSelect = function (e) {
        if (!e.detail || e.detail.sectionId !== self.sid) return;
        window.__ciNlpEditorOpen = self.sid;
        self.open(self.cfg.editorView);
      };
      this.onDeselect = function (e) {
        if (!e.detail || e.detail.sectionId !== self.sid) return;
        window.__ciNlpEditorOpen = null;
        self.close();
      };
      document.addEventListener('shopify:section:select', this.onSelect);
      document.addEventListener('shopify:section:deselect', this.onDeselect);
      // Après une modification de réglage, la section est rechargée : on la rouvre si elle était affichée.
      if (window.__ciNlpEditorOpen === this.sid) this.open(this.cfg.editorView);
    }
  }

  window.customElements.define('ci-newsletter-popup', CiNewsletterPopup);

  // Retour arrière depuis la page suivante : ne pas laisser le bouton bloqué sur « Un instant… ».
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ci-nlp-submit][aria-busy="true"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
    });
  });
})();
